import Vue from 'vue'
import './axios'
import './auth'
import './platform/pc'
import '../theme/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './register-global-components'
import _typeof from '@/utils/typeof.js'
import '@/utils/vue-directive'
import 'utils/validate'
import './assets/iconfont-hg/iconfont.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfont-pc/iconfont.css'
import './prototype'
// import 'amfe-flexible'
import env from './api'
// 自动注册全局组件
import './plugins/global-components'

function getURL () {
  env.then(res => {
    Vue.axios.defaults.baseURL = res.api_server
    for (let key in res.beian) {
      let url = window.location.hostname
      if (url.indexOf(key) > -1) {
        localStorage.setItem('ForTheRecord', res.beian[key])
      }
    }
    api(res.api_server)
  })
}

async function getTenantInfo (baseURL) {
  // 将类型判定，挂载到全局_上
  // console.log(store)
  // let url = window.location.hostname
  // let res = await store.dispatch('getTenantInfo', url)
  let res = {
    id:'lh',
    gateway:baseURL,
    menuLogoUrl:require('@/assets/images/logo.png'),
    loginLogoUrl:require('@/assets/images/logo.png'),
  }
  // console.log('该域名对应的租户信息', res)
  Vue.axios.defaults.headers['Tenant'] = res.id
  // 主要的功能业务接口的baseUrl根据接口返回的gateway设置
  Vue.axios.defaults.baseURL = res.gateway
  // 更新租户信息
  // res.id = res.id === 'demo' ? 'ucas' : res.id
  store.commit('updateTenantInfo', res)
}

// 确保宏任务最后执行，即先获取到租户信息再创建vue实例
async function api (baseURL) {
  await getTenantInfo(baseURL)
  window._ = _typeof
  Vue.config.productionTip = false
  // 让axios在所有请求的时候带上cookie - 微服务平台需要
  Vue.axios.defaults.withCredentials = true
  window.vm = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
export default getURL()
